/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPANDABLE SECTION - SECTION GROUP V2 : STYLES --------------- ++++++++++ */
export default theme => ({
  sectiongroupv2: {
    display: 'flex',
    flexDirection: 'column',
    gap: pxToEm(16),
    '&.disabled': {
      opacity: 0.4,
      pointerEvents: 'none'
    },
    '& > .header': {
      display: 'flex',
      flexDirection: 'column',
      gap: pxToEm(8),
      width: '50%',
      '& h3.title': {
        fontWeight: 700,
        fontSize: pxToEm(16)
      },
      '& p.description': {
        fontSize: pxToEm(14),
        lineHeight: pxToEm(16),
        textAlign: 'justify'
      }
    },
    '& > .content': {
      display: 'flex',
      rowGap: props => pxToEm(props.rowGap || 24),
      columnGap: pxToEm(32),
      borderLeft: '2px solid #fff',
      '&.direction-column': {
        flexDirection: 'column'
      },
      '&.indented-true': {
        paddingLeft: pxToEm(24),
        borderLeft: '2px solid #ccd1e6'
      }
    }
  }
});
